import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import './SimplePage.css';
import ParticleCanvas from '../components/ui/ParticleCanvas';

const OPENINGS = [
  { title: 'Senior Full-Stack Engineer', team: 'Engineering', location: 'Remote', type: 'Full-time' },
  { title: 'AI/ML Engineer', team: 'Engineering', location: 'Remote', type: 'Full-time' },
  { title: 'Product Designer (UI/UX)', team: 'Design', location: 'Remote', type: 'Full-time' },
  { title: 'Growth Marketing Manager', team: 'Marketing', location: 'Remote', type: 'Full-time' },
  { title: 'Customer Success Manager', team: 'Support', location: 'Remote', type: 'Full-time' },
  { title: 'Sales Development Representative', team: 'Sales', location: 'Remote', type: 'Full-time' },
];

const PERKS = [
  { icon: '🌍', title: '100% Remote', desc: 'Work from anywhere in the world. We are fully distributed and async-first.' },
  { icon: '💰', title: 'Competitive Salary', desc: 'Market-rate compensation with equity options for all full-time roles.' },
  { icon: '📅', title: 'Flexible Hours', desc: 'We care about output, not when you are logged in. Work when you are at your best.' },
  { icon: '🚀', title: 'Fast Growth', desc: 'Join early and grow with the company. Your impact is immediate and visible.' },
  { icon: '🎓', title: 'Learning Budget', desc: '$1,000/year for courses, books, and conferences to keep your skills sharp.' },
  { icon: '🏖️', title: 'Unlimited PTO', desc: 'Take the time you need to recharge. Minimum 15 days encouraged per year.' },
];

export default function CareersPage() {
  return (
    <div className="simple-page">
      <SEO
        title="Careers at Zepliq — Join the AI Automation Revolution"
        description="Work at Zepliq and help build the future of AI-powered business communication. We're hiring engineers, marketers, and sales professionals. Remote-first, fast-growing team."
        keywords="Zepliq careers, jobs at Zepliq, WhatsApp automation jobs, AI startup careers, remote jobs chatbot, tech jobs Pakistan"
        canonical="/careers"
      />

      <section className="simple-hero">
        <ParticleCanvas className="simple-hero__canvas" />
        <div className="simple-hero__blob simple-hero__blob--1" aria-hidden="true" />
        <div className="simple-hero__blob simple-hero__blob--2" aria-hidden="true" />
        <div className="container simple-hero__inner">
          <span className="badge badge-brand">Careers</span>
          <h1 className="display-xl simple-hero__title">
            Build the future of<br />
            <span className="gradient-text">business automation.</span>
          </h1>
          <p className="text-lg simple-hero__sub">
            We are a small, ambitious team on a mission to automate customer conversations for businesses worldwide.
            If you love building things that matter, we want to hear from you.
          </p>
        </div>
      </section>

      <section className="simple-section section">
        <div className="container">

          <div className="simple-header">
            <span className="badge badge-accent">Perks & Benefits</span>
            <h2 className="display-lg">Why join Zepliq</h2>
          </div>
          <div className="simple-grid-3">
            {PERKS.map(p => (
              <div key={p.title} className="simple-card">
                <span className="simple-card__emoji">{p.icon}</span>
                <h3 className="simple-card__title">{p.title}</h3>
                <p className="simple-card__desc">{p.desc}</p>
              </div>
            ))}
          </div>

          <div className="simple-divider" />

          <div className="simple-header">
            <span className="badge badge-brand">Open Roles</span>
            <h2 className="display-lg">Current openings</h2>
            <p className="text-lg" style={{ color: 'var(--text-secondary)' }}>All positions are fully remote and open globally.</p>
          </div>
          <div className="careers-list">
            {OPENINGS.map(job => (
              <div key={job.title} className="careers-item">
                <div className="careers-item__info">
                  <h3 className="careers-item__title">{job.title}</h3>
                  <div className="careers-item__meta">
                    <span className="careers-item__tag">{job.team}</span>
                    <span className="careers-item__tag">{job.location}</span>
                    <span className="careers-item__tag">{job.type}</span>
                  </div>
                </div>
                <Link to="/contact" className="btn btn-secondary">Apply Now</Link>
              </div>
            ))}
          </div>

          <div className="simple-divider" />

          <div className="simple-cta-box">
            <h2 className="display-md">Don't see your role?</h2>
            <p className="text-lg">We are always looking for talented people. Send us your CV and tell us how you can help.</p>
            <div className="simple-cta-actions">
              <Link to="/contact" className="btn btn-primary btn-lg">Get in Touch</Link>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}
